import { SubChecklistCard } from 'types/electionService';
import PageSidebar from 'components/common/checklist/PageSidebar';
import { getMilestones } from 'global/checklists-helpers/SubscriberChecklistHelper';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { ChecklistOption } from 'types/enrollmentService';
import { Group } from 'types/groupService';

interface Props {
  group: Pick<Group, 'name' | 'id'>;
  checklistOptions: ChecklistOption<SubChecklistCard>[];
}

const SubscriberTaskSidebar: React.FC<Props> = observer(({ group, checklistOptions }) => {
  const history = useHistory();

  const redirectToProfile = (): void => {
    history.push(`/employee?groupId=${group.id}`);
  };

  return (
    <PageSidebar
      groupName={group.name}
      infoMap={{}}
      milestones={getMilestones(checklistOptions)}
      viewProfileText="View Benefits Dashboard"
      onViewProfileClick={group.id ? redirectToProfile : undefined}
    />
  );
});

export default SubscriberTaskSidebar;
